import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { default as ordersStore } from 'store/ordersStore';
import { Positions } from 'constants/enums';
import agent from 'api/agent';
import { useStyles } from '../styles';
import { useNavigationCounterLayout } from '../useNavigationCounterLayout';
import { useAppSelector } from 'index';
import { SignalREvent, signalRService } from 'services/signalR';
import { Box } from '@material-ui/core';

export default function NewOrdersCounter(props: { isOpen: boolean }) {
    const classes = useStyles();
    const newOrders = useAppSelector((state) => state.orders.newOrders);
    const user = useAppSelector((state) => state.user);
    const currentPosition = useAppSelector((state) => state.user).restaurants.find(
        (res) => res.id === user.currentRestaurantId
    )?.currentPosition;
    const { left, width } = useNavigationCounterLayout({
        isOpen: props.isOpen,
        count: newOrders,
    });
    const dispatch = useDispatch();
    const userRestaurantId = useRef('');
    const userCurrentPosition = useRef<Positions | undefined>(undefined);

    useEffect(() => {
        if (user.currentRestaurantId) {
            userRestaurantId.current = user.currentRestaurantId;
        } else {
            agent.User.GetUserRestaurants().then((response) => {
                userRestaurantId.current = response.currentRestaurantId;
                dispatch({
                    type: 'USER_GET_RESTAURANTS_SUCCESS',
                    restaurants: response,
                });
            });
        }
    }, [user.currentRestaurantId]); // eslint-disable-line

    useEffect(() => {
        if (currentPosition) {
            userCurrentPosition.current = currentPosition;
            dispatch(ordersStore.actionCreators.getNewOrders(Positions.WAITER));
        }

        //TRY TO DISABLE GET NEW ORDERS LOOP
        /* const timer = setInterval(() => {
            dispatch(OrdersStore.actionCreators.getNewOrders());
        }, 60000);
        return () => clearInterval(timer); */
    }, [currentPosition]); // eslint-disable-line

    useEffect(() => {
        return signalRService.subscribe(SignalREvent.OrdersCountChanged, handleMessage);
    }, []);

    function handleMessage(count: number) {
        ordersStore.actionCreators.setNewOrdersCount(count);
    }

    return (
        <Box position="relative" key="newOrders">
            <Box className={classes.newOrdersCount} left={left} width={width}>
                {newOrders}
            </Box>
        </Box>
    );
}
